(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ls26-gift-finder"] && !Shopify.designMode) return;
  try {
    (() => {
    function chooseCandidates(templates, style, limit) {
      const seenProducts = new Set();
      const valid = templates.filter(item => {
        const key = item.dataset.productId || item;
        const price = Number(item.dataset.price);
        if (!Number.isFinite(price) || price < 0 || seenProducts.has(key)) return false;
        seenProducts.add(key);
        return true;
      });
      const sameStyle = item => style === 'any' || item.dataset.groups.split(/\s+/).includes(style);
      const available = item => item.dataset.available === 'true';
      const withinBudget = item => Number(item.dataset.price) <= limit;
      const tier = item => (sameStyle(item) ? 0 : 4) + (available(item) ? 0 : 2) + (withinBudget(item) ? 0 : 1);
      const candidates = valid.sort((a, b) => tier(a) - tier(b) || Number(a.dataset.priority) - Number(b.dataset.priority) || Number(a.dataset.price) - Number(b.dataset.price));
      let ranked = candidates;
      if (style === 'any') {
        const exact = candidates.filter(item => tier(item) === 0);
        const firstByGroup = [];
        const seenGroups = new Set();
        exact.forEach(item => {
          const group = item.dataset.groups.trim().split(/\s+/)[0] || 'other';
          if (!seenGroups.has(group)) { firstByGroup.push(item); seenGroups.add(group); }
        });
        ranked = [...firstByGroup, ...candidates.filter(item => !firstByGroup.includes(item))];
      }
      const selected = ranked.slice(0, 4);
      let mode = 'mixed';
      if (!selected.length) mode = 'empty';
      else if (selected.every(item => sameStyle(item) && available(item) && withinBudget(item))) mode = 'exact';
      else if (selected.every(item => sameStyle(item) && available(item))) mode = 'overBudget';
      else if (selected.every(item => sameStyle(item) && !available(item))) mode = 'unavailable';
      return { mode, selected };
    }
    function setupFinder(root) {
      if (root.dataset.finderReady) return;
      const form = root.querySelector('[data-finder-form]');
      const results = root.querySelector('[data-finder-results]');
      const grid = root.querySelector('[data-finder-grid]');
      const notice = root.querySelector('[data-finder-notice]');
      const templates = Array.from(root.querySelectorAll('template[data-finder-product]'));
      const radios = Array.from(form.querySelectorAll('input[type="radio"]'));
      const widen = root.querySelector('[data-finder-widen]');
      const other = root.querySelector('[data-finder-other]');
      function recommend() {
        const style = radios.find(input => input.name.endsWith('-style') && input.checked);
        const budget = radios.find(input => input.name.endsWith('-budget') && input.checked);
        const limit = budget.value === 'any' ? Infinity : Number(budget.value);
        const { mode, selected } = chooseCandidates(templates, style.value, limit);
        const fragment = document.createDocumentFragment();
        selected.forEach(template => {
          const card = template.content.cloneNode(true);
          if (Number(template.dataset.price) > limit) {
            const priceNote = document.createElement('p');
            priceNote.className = 'lsh-finder-price-note';
            priceNote.textContent = notice.dataset.priceNote;
            const price = card.querySelector('.lsgc-price');
            if (price) price.after(priceNote);
          }
          if (style.value !== 'any' && !template.dataset.groups.split(/\s+/).includes(style.value)) {
            const styleNote = document.createElement('p');
            styleNote.className = 'lsh-finder-price-note';
            styleNote.textContent = notice.dataset.styleNote;
            const title = card.querySelector('h3');
            if (title) title.after(styleNote);
          }
          fragment.append(card);
        });
        grid.replaceChildren(fragment);
        results.hidden = false;
        grid.hidden = selected.length === 0;
        notice.hidden = mode === 'exact';
        notice.textContent = mode === 'overBudget' ? notice.dataset.overBudget : mode === 'unavailable' ? notice.dataset.unavailable : mode === 'empty' ? notice.dataset.empty : mode === 'mixed' ? notice.dataset.mixed : '';
        widen.hidden = budget.value === 'any' || mode === 'exact';
        other.hidden = style.value === 'any' || mode === 'exact';
        root.querySelector('[data-finder-count]').textContent = mode === 'exact'
          ? (selected.length === 1 ? root.dataset.resultSingular : root.dataset.resultPlural.replace('__COUNT__', String(selected.length)))
          : (selected.length === 1 ? notice.dataset.similarSingular : notice.dataset.similarPlural.replace('__COUNT__', String(selected.length)));
        root.querySelector('[data-finder-selection]').textContent = style.nextElementSibling.textContent.trim() + ' · ' + budget.nextElementSibling.textContent.trim();
        const heading = results.querySelector('h2');
        heading.textContent = mode === 'exact' ? notice.dataset.exact : notice.dataset.alternativeHeading;
        heading.focus({preventScroll:true});
        heading.scrollIntoView({block:'nearest',behavior:'instant'});
        root.dispatchEvent(new CustomEvent('ls26:hamper-finder-results', {bubbles:true,detail:{style:style.value,budget:budget.value,count:selected.length,mode}}));
      }
      form.addEventListener('submit', event => { event.preventDefault(); recommend(); });
      form.addEventListener('change', () => {
        results.hidden = true;
        grid.replaceChildren();
        root.querySelector('[data-finder-count]').textContent = '';
      });
      widen.addEventListener('click', () => {
        radios.find(input => input.name.endsWith('-budget') && input.value === 'any').checked = true;
        recommend();
      });
      other.addEventListener('click', () => {
        radios.find(input => input.name.endsWith('-style') && input.value === 'any').checked = true;
        recommend();
      });
      form.hidden = false;
      root.querySelector('[data-finder-fallback]').hidden = true;
      root.dataset.finderReady = 'true';
    }
    document.querySelectorAll('[data-hamper-finder]').forEach(setupFinder);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hamper-finder]').forEach(setupFinder));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ls26-minimal-gift-card"] && !Shopify.designMode) return;
  try {
    (() => {
  function enableRestockForms(scope) {
    scope.querySelectorAll('[data-gift-restock]').forEach(form => {
      if (form.dataset.restockReady) return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-restock-status]');
      const input = form.querySelector('input[type="email"]');
      const originalLabel = button.textContent;
      const details = form.closest('.lsgc-restock');
      const summary = details.querySelector('summary');
      summary.setAttribute('aria-live', 'polite');
      summary.setAttribute('aria-atomic', 'true');
      summary.addEventListener('click', event => {
        if (form.dataset.saved === 'true') event.preventDefault();
      });
      button.disabled = false;
      form.dataset.restockReady = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.pending === 'true' || form.dataset.saved === 'true' || !form.reportValidity()) return;
        form.dataset.pending = 'true';
        button.disabled = true;
        button.textContent = form.dataset.busy;
        status.textContent = '';
        status.dataset.error = 'false';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const site = form.dataset.klaviyoSite;
          const variant = form.dataset.variantId;
          if (!site || !/^\d+$/.test(variant)) throw new Error('Missing restock configuration');
          const payload = {data:{type:'back-in-stock-subscription',attributes:{channels:['EMAIL'],profile:{data:{type:'profile',attributes:{email:input.value.trim()}}}},relationships:{variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::' + variant}}}}};
          const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(site), {
            method:'POST',credentials:'omit',signal:controller.signal,
            headers:{accept:'application/vnd.api+json','content-type':'application/vnd.api+json',revision:'2026-10-15'},
            body:JSON.stringify(payload)
          });
          if (response.status !== 202) throw new Error('Restock request not accepted');
          form.dataset.saved = 'true';
          details.dataset.restockSaved = 'true';
          summary.textContent = form.dataset.savedLabel;
          summary.setAttribute('aria-disabled', 'true');
          details.open = false;
          form.hidden = true;
          summary.focus({preventScroll:true});
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = form.dataset.error;
        } finally {
          clearTimeout(timeout);
          delete form.dataset.pending;
          button.disabled = form.dataset.saved === 'true';
          button.textContent = originalLabel;
        }
      });
    });
  }
  enableRestockForms(document);
  document.addEventListener('shopify:section:load', event => enableRestockForms(event.target));
  document.addEventListener('ls26:hamper-finder-results', event => enableRestockForms(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
